import React, { Component } from 'react';
import { connect } from 'react-redux';
import { _LIST_PAGINATION_MODEL } from '../../store/modules/app/models';
import { tagActions } from '../../store/modules/tag';
import {
  TAG_GROUP_LIST_SEARCH_DATA_MODEL,
  TAG_GROUP_LIST_SEARCH_OPTION_MODEL,
  TAG_GROUP_LIST_SORT_OPTION_MODEL,
} from '../../store/modules/tag/models';
import TagGroupListWrap from '../../views/tag/group/list/TagGroupListWrap';

class TagGroupListContainer extends Component {
  componentDidMount() {
    this.initiate();
  }

  /**
   * 초기 데이터 불러오기
   */
  initiate = () => {
    const { setData } = this.props;

    this.getList({
      /**
       *  검색 옵션
       */
      searchOption: TAG_GROUP_LIST_SEARCH_OPTION_MODEL,
      /**
       *  정렬 옵션
       */
      sortOption: TAG_GROUP_LIST_SORT_OPTION_MODEL,
      /**
       *  pagination
       */
      pagination: _LIST_PAGINATION_MODEL,
    });

    /**
     * 검색 박스 초기화
     */
    setData({
      path: ['tagGroupList', 'searchData'],
      value: TAG_GROUP_LIST_SEARCH_DATA_MODEL,
    });
  };

  /**
   * 리스트 불러오기
   */
  getList = async (data) => {
    const { getTagGroupList, tagGroupList } = this.props;
    const { searchOption, sortOption, pagination } = tagGroupList;

    getTagGroupList({
      searchOption,
      sortOption,
      pagination,
      ...data,
    });
  };

  render() {
    const { tagGroupList, setData } = this.props;

    return <TagGroupListWrap tagGroupList={tagGroupList} setData={setData} getList={this.getList} />;
  }
}

const mapStateToProps = (state) => {
  return {
    tagGroupList: state.tag.tagGroupList,
    tagGroupSelectList: state.tag.tagGroupSelectList,
  };
};

const mapDispatchToProps = {
  setData: tagActions.setData,
  getTagGroupList: tagActions.getTagGroupList,
};

export default connect(mapStateToProps, mapDispatchToProps)(TagGroupListContainer);
